export default {
  SET_LOADING(state, value) {
    state.loading = value
  },

  SET_ERROR(state, error) {
    state.error = error
  },

  SET_MESSAGE(state, message) {
    state.message = message
  },
  SET_REPORT(state, data) {
    state.report = data.data
  },
  SET_DAILY_REVENUE_ERROR(state, error) {
    state.dailyRevenueError = error
  },
  SET_COGS_ERROR(state, error) {
    state.cogsError = error
  },
  SET_INCOMING_INVOICES_ERROR(state, error) {
    state.incomingInvoicesError = error
  },
  SET_DAILY_REVENUE_MESSAGE(state, message) {
    state.dailyRevenueMessage = message
  },
  SET_COGS_MESSAGE(state, message) {
    state.cogsMessage = message
  },
  SET_INCOMING_INVOICES_MESSAGE(state, message) {
    state.incomingInvoicesMessage = message
  }
}